import { PaymentService } from "@/api";
import { useMutation } from "@tanstack/react-query";

export const useGeneratePromptPayQr = () => {
    const result = useMutation({
        mutationFn: ({ childFrameId, amount }: { childFrameId: string, amount?: number }) => PaymentService.paymentControllerGenerateQr({ childFrameId, amount }),
    });

    return result;
}